import {
  ByIdPayload,
  FailByIdPayload,
  ListReducerTypes,
  NormalizedList,
  PayloadAction,
  RemoveIdByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const ItemImageAddPendingListActionTypes: ListReducerTypes = {
  request: uniqueActionType('[item/image] Add pending list'),
  requestFail: uniqueActionType('[item/image] Add pending list fail'),
  requestSuccess: uniqueActionType('[item/image] Add pending list success'),
  requestClearErrors: uniqueActionType('[item/image] Add pending list clear errors'),
  requestClear: uniqueActionType('[item/image] Add pending list clear'),
  removeId: uniqueActionType('[item/image] Add pending list remove id')
};

export class ItemImageAddPendingListFailAction implements PayloadAction {
  readonly type = ItemImageAddPendingListActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ItemImageAddPendingListSuccessAction implements PayloadAction {
  readonly type = ItemImageAddPendingListActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedList>) {
  }
}

export class ItemImageAddPendingListClearErrorsAction implements PayloadAction {
  readonly type = ItemImageAddPendingListActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ItemImageAddPendingListClearAction implements PayloadAction {
  readonly type = ItemImageAddPendingListActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class ItemImageAddPendingListRemoveIdAction implements PayloadAction {
  readonly type = ItemImageAddPendingListActionTypes.removeId;

  constructor(public payload: RemoveIdByIdPayload) {
  }
}
